const Pagination = ({ onPrevious, onNext, currentPage, totalPages }) => {
  const isFirstPage = currentPage === 1;
  const isLastPage = currentPage === totalPages;

  return (
    <div className="flex justify-between mt-4 text-sm text-gray-600">
      <span
        onClick={!isFirstPage ? onPrevious : undefined}
        className={`cursor-pointer hover:underline hover:text-orange-500 ${
          isFirstPage ? 'text-gray-400 cursor-not-allowed' : ''
        }`}
      >
        ← Previous
      </span>

      <span
        onClick={!isLastPage ? onNext : undefined}
        className={`cursor-pointer hover:underline hover:text-orange-500 ${
          isLastPage ? 'text-gray-400 cursor-not-allowed' : ''
        }`}
      >
        Next →
      </span>
    </div>
  );
};

export default Pagination;

